/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalQueryServiceErrorsAPI
 * @hideconstructor
 * @classdesc API class that is used to handle query service errors (and compatible predictService errors such as FPD).
 */
define([], () => {
	class InternalQueryServiceErrorAPI {

		/**
		 * @function InternalQueryServiceAPI#handleQueryError
		 * @description Handle query service request errors (which includes errors and prompt faults)
		 * @param {Object} queryError - an object holding queryError information (not explicitly named)
		 * @param {Object} queryError.error - the jqXHR error from the initial query.
		 * @param {Object} queryError.promptsState - An object that holds information about the number of re-prompts
		 * @param {Object} queryError.visualization - the visualizationAPI that threw the error.
		 * @param {Object} [queryError.isPreview] - if specified, this error is for a visualization preview.
		 * 		Note that if visualizationAPI is an internal api, isPreview does not need to be specified.
		 * @param {Object} queryError.content - the contentAPI for the visualization that threw the error
		 * @returns {Promise} - a promise which resolves with prompt values, or rejects with error codes.
		 */
		handleQueryError() {}
	}

	return InternalQueryServiceErrorAPI;
});
